export default "__VITE_ASSET__BnD0BEIl__"